define(['angular'], function(angular) {


    function UserNetworkProvider() {
        var bdcUrl;

        /**
         * Set KYP url
         * @param {String} url
         */
        this.setBDCUrl = function setBDCUrl(url) {
            bdcUrl = url;
        };

        this.$get = [
            '$http',
            function($http) {
                var self = {};

                /**
                 * get user network
                 * @return {Promise}
                 */
                self.getUserNetwork = function getUserNetwork(uid) {
                    return $http.get(bdcUrl + 'user/user-network').then(function(res) {
                        return res.data;
                    });
                };

                return self;
            }
        ];
    }

    angular.module('app.bdc.list.userNetworkProvider', []).provider('userNetwork', UserNetworkProvider);
});
